// extracted by mini-css-extract-plugin
export default {"description":"Inventory_description__+RemS","field":"Inventory_field__8wUs+","editor":"Inventory_editor__MsKwY","group":"Inventory_group__0B2A7"};